<template>
  <div class="navbar-custom">
    <div class="topbar container-fluid">
      <div class="d-flex align-items-center gap-lg-2 gap-1">
        <!-- Topbar Brand Logo -->
        <div class="logo-topbar">
          <!-- Logo light -->
          <router-link to="/" class="logo-light">
            <span class="logo-lg">
              <img src="@/assets/images/logo.svg" alt="logo" />
            </span>
            <span class="logo-sm">
              <img src="@/assets/images/logo.svg" alt="small logo" />
            </span>
          </router-link>

          <!-- Logo Dark -->
          <router-link to="/" class="logo-dark">
            <span class="logo-lg">
              <img src="@/assets/images/logo.svg" alt="dark logo" />
            </span>
            <span class="logo-sm">
              <img src="@/assets/images/logo.svg" alt="small logo" />
            </span>
          </router-link>
        </div>

        <!-- Sidebar Menu Toggle Button -->
        <button class="button-toggle-menu">
          <i class="mdi mdi-menu"></i>
        </button>

        <!-- Horizontal Menu Toggle Button -->
        <button
          class="navbar-toggle horizontal-button-toggle-menu"
          data-bs-toggle="collapse"
          data-bs-target="#topnav-menu-content"
        >
          <div class="lines">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
      </div>

      <ul class="topbar-menu d-flex align-items-center gap-3">
        <li class="dropdown d-lg-none">
          <a
            class="nav-link dropdown-toggle arrow-none"
            data-bs-toggle="dropdown"
            role="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <i class="ri-search-line font-22"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-animated dropdown-lg p-0">
            <b-form class="p-3">
              <b-form-input type="search" placeholder="Search ..." aria-label="Recipient's username" />
            </b-form>
          </div>
        </li>

        <li class="d-none d-sm-inline-block">
          <a class="nav-link" @click="toggleRightSidebar">
            <i class="ri-settings-3-line font-22"></i>
          </a>
        </li>

        <li class="d-none d-sm-inline-block">
          <div id="light-dark-mode" v-b-tooltip.hover.bottom class="nav-link" title="Theme Mode">
            <i class="ri-moon-line font-22"></i>
          </div>
        </li>

        <li class="d-none d-md-inline-block">
          <button class="nav-link" @click="fullScreenListener">
            <i class="ri-fullscreen-line font-22"></i>
          </button>
        </li>

        <b-nav-item-dropdown
          toggle-class="arrow-none"
          class="dropdown"
          menu-class="dropdown-menu dropdown-menu-end dropdown-menu-animated profile-dropdown"
          data-bs-toggle="dropdown"
          role="button"
          aria-haspopup="false"
          aria-expanded="false"
        >
          <template #button-content>
            <div class="nav-link arrow-none nav-user px-2">
              <span class="account-user-avatar">
                <span class="user-initial rounded-circle">{{ user.fullName.charAt(0).toUpperCase() }}</span>
              </span>
              <span class="d-lg-flex flex-column gap-1 d-none">
                <h5 class="my-0">{{ user.fullName }}</h5>
                <h6 class="my-0 fw-normal text-start">{{ user.type }}</h6>
              </span>
            </div>
          </template>

          <b-dropdown-item href="/profile" class="">
            <i class="ri-account-circle-line fs-18 align-middle me-1"></i>
            <span>My Account</span>
          </b-dropdown-item>

          <b-dropdown-item href="/logout">
            <i class="ri-logout-box-line fs-18 align-middle me-1"></i>
            <span>Logout</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { useLayoutStore } from '@/stores/layout'
import { useAuthStore } from '@/requests/Auth'

export default {
  data() {
    const useLayout = useLayoutStore()
    const user = useAuthStore().getCurrentUser()

    return {
      useLayout,
      user: {
        fullName: user?.firstName ? user?.firstName + ' ' + user?.lastName : user?.email || '',
        type: user?.type || '',
      },
    }
  },
  methods: {
    toggleRightSidebar() {
      this.useLayout.isRightSidebarOpen = !this.useLayout.isRightSidebarOpen
    },
    fullScreenListener() {
      document.body.classList.toggle('fullscreen-enable')
      if (!document.fullscreenElement) {
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen()
        }
      } else {
        if (document['exitFullscreen']) {
          document['exitFullscreen']()
        }
      }
    },
  },
}
</script>
<style scoped>
.user-initial {
  display: block;
  width: 32px;
  height: 32px;
  background-color: #007bff;
  color: white;
  text-align: center;
  line-height: 32px;
  border-radius: 50%;
  font-size: 16px;
}
</style>
